export enum LabelPosition {
	Left = 'left',
	LeftAligned = 'left-aligned',
	SpaceBetween = 'aligned-space-between',
	TopStacked = 'top-aligned-stacked',
	TopAlign = 'top-aligned-inline',
	TopLeftAlign = 'top-left-aligned',
}
